import {createUrl, getObjects} from "./api_common";

export const ENDPOINT_POSTS = '/api/posts'

export function getPosts(parameters = {}) {
    const defaultParameters = {
        isEdited: true,
        isVisible: true,
        itemsPerPage: 1
    }

    let url = process.env.REACT_APP_API_URL + ENDPOINT_POSTS
    url = createUrl(url, parameters, defaultParameters)
    return getObjects(url)
}